import './TeamStats.scss';
import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useProtectedInterval } from '../../hooks/useProtectedInterval';

export default function TeamStats() {
    const { t } = useTranslation('layout');
    const api_url = useSelector((state) => state.API_URL);

    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchStats = useCallback(async () => {
        const jwtToken = localStorage.getItem('accessToken');
        if (!jwtToken) return;
        try {
            const response = await fetch(api_url + 'teamlead/stats/', {
                headers: { 'Authorization': `JWT ${jwtToken}`, 'Content-Type': 'application/json' },
            });
            if (response.ok) {
                setStats(await response.json());
            }
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, [api_url]);

    useProtectedInterval(fetchStats, [api_url]);

    if (loading) return <div style={{ padding: '24px' }}><h2>{t('sidebar.menu.teamStats')}</h2><p>Загрузка...</p></div>;
    if (!stats) return <div style={{ padding: '24px' }}><h2>{t('sidebar.menu.teamStats')}</h2><p>Нет данных</p></div>;

    const { today, traders, teamlead_balance, total_team_balance } = stats;

    return (
        <div className="TeamStats">
            <h2>{t('sidebar.menu.teamStats')}</h2>

            {/* Сводка за сегодня */}
            <div className="TeamStats__cards">
                <div className="TeamStats__card">
                    <span className="TeamStats__card-label">Заявки сегодня</span>
                    <span className="TeamStats__card-value">{today.total}</span>
                </div>
                <div className="TeamStats__card TeamStats__card--success">
                    <span className="TeamStats__card-label">Успешные</span>
                    <span className="TeamStats__card-value">{today.success}</span>
                </div>
                <div className="TeamStats__card TeamStats__card--cancel">
                    <span className="TeamStats__card-label">Отменены</span>
                    <span className="TeamStats__card-value">{today.canceled}</span>
                </div>
                <div className="TeamStats__card">
                    <span className="TeamStats__card-label">Конверсия</span>
                    <span className="TeamStats__card-value">{today.conversion}%</span>
                </div>
                <div className="TeamStats__card">
                    <span className="TeamStats__card-label">Оборот</span>
                    <span className="TeamStats__card-value">{today.turnover.toLocaleString()}</span>
                </div>
                <div className="TeamStats__card">
                    <span className="TeamStats__card-label">Ваш баланс</span>
                    <span className="TeamStats__card-value">{teamlead_balance} $</span>
                </div>
                <div className="TeamStats__card">
                    <span className="TeamStats__card-label">Баланс команды</span>
                    <span className="TeamStats__card-value">{total_team_balance} $</span>
                </div>
            </div>

            {/* По каждому трейдеру */}
            <h3 className="TeamStats__subtitle">По трейдерам (сегодня)</h3>

            <div className="TeamStats__table-wrap">
                <table className="TeamStats__table">
                    <thead>
                        <tr>
                            <th>Трейдер</th>
                            <th>Баланс</th>
                            <th>Успешные</th>
                            <th>Всего</th>
                            <th>Реквизиты</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        {traders.map(tr => (
                            <tr key={tr.username} className={tr.is_frozen ? 'TeamStats__row--frozen' : ''}>
                                <td className="TeamStats__username">{tr.username}</td>
                                <td className={`TeamStats__balance${tr.balance_usdt < 0 ? ' TeamStats__balance--neg' : ''}`}>
                                    {tr.balance_usdt} $
                                </td>
                                <td className="TeamStats__success">{tr.deals_success}</td>
                                <td>{tr.deals_total}</td>
                                <td>{tr.active_creds}</td>
                                <td>
                                    {tr.is_frozen ? (
                                        <span className="TeamStats__badge TeamStats__badge--frozen">Заморожен</span>
                                    ) : tr.active_creds > 0 ? (
                                        <span className="TeamStats__badge TeamStats__badge--ok">В работе</span>
                                    ) : (
                                        <span className="TeamStats__badge TeamStats__badge--idle">Нет реквизитов</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
